import { Controller } from "@hotwired/stimulus"

// Story View Controller
// Handles view toggle and filter changes
export default class extends Controller {
  static targets = ["viewToggle", "storiesContainer"]

  connect() {
    // Initialize any animations or effects
    this.animateCardsIn()
  }

  animateCardsIn() {
    // Cards animate in via CSS, this is for any additional JS-based animations
    const cards = this.element.querySelectorAll('.story-card')
    cards.forEach((card, index) => {
      card.style.opacity = '0'
      card.style.transform = 'translateY(20px)'
      
      setTimeout(() => {
        card.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out'
        card.style.opacity = '1'
        card.style.transform = 'translateY(0)'
      }, index * 50)
    })
  }

  // Handle view toggle changes
  switchView(event) {
    const view = event.currentTarget.dataset.view
    // Navigation handled by links, but we could add transition effects here
  }
}

